import React, { useEffect, useState } from 'react';
import { Plus, Edit, Trash2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAppSelector } from '@/store/hooks';


export interface YoutubeChannel {
    _id: string;
    channelName: string;
    channelPhoto: string | null;
    subscribers: number;
    link: string;
    status: 'active' | 'inactive' | '';
    createdAt: string;
    updatedAt: string;
}
const CourseList: React.FC = () => {
    const baseUrl = import.meta.env.VITE_API_BASE_URL;

    const [ProductData, setProductData] = useState<YoutubeChannel[]>([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [entriesPerPage, setEntriesPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const { token } = useAppSelector((state) => state.auth);
    const navigate = useNavigate();
    useEffect(() => {
        fetch(`${baseUrl}/products`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
            .then(res => res.json())
            .then(data => {
                console.log("Fetched Product Data:", data.data);
                if (Array.isArray(data?.data)) {
                    setProductData(data.data);
                }
            })
            .catch(err => {
                console.error("Failed to fetch slider data:", err);
            });
    }, []);

    console.log("Fetched YouTube Channel Data:", ProductData);

    const filteredData = ProductData.filter(item =>
        item.title?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.link?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const totalPages = Math.ceil(filteredData.length / entriesPerPage);
    const startIndex = (currentPage - 1) * entriesPerPage;
    const endIndex = startIndex + entriesPerPage;
    const currentData = filteredData.slice(startIndex, endIndex);

    const handleStatusToggle = (id: number) => {
        // Handle status toggle logic
    };

    const handleDelete = async (id: string) => {
        try {
            await axios.delete(`${baseUrl}/products/${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            // ✅ Update state immediately
            setProductData((prev) => prev.filter((channel) => channel._id !== id));

            alert("Book deleted successfully ✅");
        } catch (error: any) {
            console.error("Error deleting slider:", error.response?.data || error.message);
            alert(error.response?.data?.message || "Failed to delete slider");
        }
    };


    const handleEdit = (id: number) => {
        // Handle edit logic
        console.log('Edit item with id:', id);
        navigate(`/youtube-channels/edit/${id}`);
    };

    const renderStatus = (status: string) => {
        if (status === 'active') {
            return (
                <span className="badge bg-success text-white fs-14 rounded-2">
                    Active
                </span>
            );
        }
        return null; // Return empty for inactive/empty status
    };

    const renderImage = (imageSrc: string, title: string) => {
        return (
            <img src={imageSrc} alt={title} width="100" />
        );
    };


    console.log("currentData", ProductData)
    return (
        <div className="main-content app-content mt-0">
            <div className="side-app">
                {/*{ container start }*/}
                <div className="main-container container-fluid">
                    {/*{ PAGE HEADER START }*/}
                    <div className="page-header">
                        {/*<h1 class="page-title">User list</h1>*/}
                        <div>
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <a href="index.php">Home</a>
                                </li>
                                <li className="breadcrumb-item active" aria-current="page">
                                    All Courses List
                                </li>
                            </ol>
                        </div>
                        <button
                            className="btn btn-primary"
                            onclick="window.location.href='add_courses.php'"
                            name="active"
                        >
                            {" "}
                            <i className="icon-plus" /> Add Course
                        </button>
                    </div>
                    {/*{ PAGE HEADER END }*/}
                    <div className="row">
                        <div className="col-12">
                            <div className="card table-card">
                                <div className="card-body">
                                    <div className="table-responsive">
                                        <div
                                            id="UserList_wrapper"
                                            className="dataTables_wrapper dt-bootstrap5 no-footer"
                                        >
                                            <div className="row">
                                                <div className="col-sm-12 col-md-6">
                                                    <div className="dataTables_length" id="UserList_length">
                                                        <label>
                                                            Show{" "}
                                                            <select
                                                                name="UserList_length"
                                                                aria-controls="UserList"
                                                                className="form-select form-select-sm"
                                                            >
                                                                <option value={10}>10</option>
                                                                <option value={25}>25</option>
                                                                <option value={50}>50</option>
                                                                <option value={100}>100</option>
                                                            </select>{" "}
                                                            entries
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="col-sm-12 col-md-6">
                                                    <div id="UserList_filter" className="dataTables_filter">
                                                        <label>
                                                            Search:
                                                            <input
                                                                type="search"
                                                                className="form-control form-control-sm"
                                                                placeholder=""
                                                                aria-controls="UserList"
                                                            />
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row dt-row">
                                                <div className="col-sm-12">
                                                    <table
                                                        className="table dataTable no-footer"
                                                        id="UserList"
                                                        aria-describedby="UserList_info"
                                                    >
                                                        <thead>
                                                            <tr>
                                                                <th
                                                                    className="sorting sorting_asc"
                                                                    tabIndex={0}
                                                                    aria-controls="UserList"
                                                                    rowSpan={1}
                                                                    colSpan={1}
                                                                    aria-sort="ascending"
                                                                    aria-label="S.No: activate to sort column descending"
                                                                    style={{ width: "35.2812px" }}
                                                                >
                                                                    S.No
                                                                </th>
                                                                <th
                                                                    className="sorting"
                                                                    tabIndex={0}
                                                                    aria-controls="UserList"
                                                                    rowSpan={1}
                                                                    colSpan={1}
                                                                    aria-label="Category: activate to sort column ascending"
                                                                    style={{ width: "78.7578px" }}
                                                                >
                                                                    Category
                                                                </th>
                                                                <th
                                                                    className="sorting"
                                                                    tabIndex={0}
                                                                    aria-controls="UserList"
                                                                    rowSpan={1}
                                                                    colSpan={1}
                                                                    aria-label="Sub Category: activate to sort column ascending"
                                                                    style={{ width: "78.7578px" }}
                                                                >
                                                                    Sub Category
                                                                </th>
                                                                <th
                                                                    className="sorting"
                                                                    tabIndex={0}
                                                                    aria-controls="UserList"
                                                                    rowSpan={1}
                                                                    colSpan={1}
                                                                    aria-label="Title: activate to sort column ascending"
                                                                    style={{ width: "166.078px" }}
                                                                >
                                                                    Title
                                                                </th>
                                                                <th
                                                                    className="sorting"
                                                                    tabIndex={0}
                                                                    aria-controls="UserList"
                                                                    rowSpan={1}
                                                                    colSpan={1}
                                                                    aria-label="Description: activate to sort column ascending"
                                                                    style={{ width: "99.3594px" }}
                                                                >
                                                                    Description
                                                                </th>
                                                                <th
                                                                    className="sorting"
                                                                    tabIndex={0}
                                                                    aria-controls="UserList"
                                                                    rowSpan={1}
                                                                    colSpan={1}
                                                                    aria-label="Image: activate to sort column ascending"
                                                                    style={{ width: "51.6797px" }}
                                                                >
                                                                    Image
                                                                </th>
                                                                <th
                                                                    className="sorting"
                                                                    tabIndex={0}
                                                                    aria-controls="UserList"
                                                                    rowSpan={1}
                                                                    colSpan={1}
                                                                    aria-label="Features: activate to sort column ascending"
                                                                    style={{ width: "75.375px" }}
                                                                >
                                                                    Features
                                                                </th>
                                                                <th
                                                                    className="sorting"
                                                                    tabIndex={0}
                                                                    aria-controls="UserList"
                                                                    rowSpan={1}
                                                                    colSpan={1}
                                                                    aria-label="FAQs: activate to sort column ascending"
                                                                    style={{ width: "39.0156px" }}
                                                                >
                                                                    FAQs
                                                                </th>
                                                                <th
                                                                    className="sorting"
                                                                    tabIndex={0}
                                                                    aria-controls="UserList"
                                                                    rowSpan={1}
                                                                    colSpan={1}
                                                                    aria-label="Status: activate to sort column ascending"
                                                                    style={{ width: "53.8438px" }}
                                                                >
                                                                    Status
                                                                </th>
                                                                <th
                                                                    className="sorting"
                                                                    tabIndex={0}
                                                                    aria-controls="UserList"
                                                                    rowSpan={1}
                                                                    colSpan={1}
                                                                    aria-label="Action: activate to sort column ascending"
                                                                    style={{ width: "55.5312px" }}
                                                                >
                                                                    Action
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr className="odd">
                                                                <td className="sorting_1">1</td>
                                                                <td>RRB</td>
                                                                <td />
                                                                <td>
                                                                    399 NCERT Science Live + Recorded Batch for
                                                                    Railway Group D/NTPC/ALP/TECH/JE 2025 (Physics,
                                                                    Chemistry, Biology)
                                                                </td>
                                                                <td>
                                                                    <p>
                                                                        प्रिय विद्यार्थियों, यह ₹399 NCERT Science L...
                                                                    </p>
                                                                </td>
                                                                <td>
                                                                    <img
                                                                        src="../../images/courses/17480037952025-05-20-0.7248253415346387.jpg"
                                                                        alt=""
                                                                        width={70}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <a href="view_course_features.php?course_id=1">
                                                                        Features
                                                                    </a>
                                                                </td>
                                                                <td>
                                                                    <a href="view_course_faq.php?course_id=1">FAQs</a>
                                                                </td>
                                                                <td>
                                                                    <a
                                                                        href=""
                                                                        id="f_status"
                                                                        onclick="franchise_status(1)"
                                                                    >
                                                                        <span className="badge bg-success text-white fs-14 rounded-2">
                                                                            Active
                                                                        </span>
                                                                    </a>
                                                                </td>
                                                                <td>
                                                                    <a
                                                                        href="edit_courses.php?id=1"
                                                                        className="bg-primary-transparent text-primary p-2 rounded-2 text-center fs-16 me-2"
                                                                    >
                                                                        <i className="fe fe-edit" />
                                                                    </a>
                                                                    <a
                                                                        href=""
                                                                        id="f_status"
                                                                        className="bg-danger-transparent text-danger p-2 rounded-2 text-center fs-16"
                                                                        onclick="delete_f(1)"
                                                                    >
                                                                        <i className="fe fe-trash-2" />
                                                                    </a>
                                                                </td>
                                                            </tr>
                                                            <tr className="even">
                                                                <td className="sorting_1">2</td>
                                                                <td>RRB</td>
                                                                <td />
                                                                <td>
                                                                    Physics &amp; Chemistry Live batch-2025 एकदम नया
                                                                    बैच
                                                                </td>
                                                                <td>
                                                                    <p>
                                                                        यह कोर्स आपके फोन में 6 Month तक रहेगा किसी ...
                                                                    </p>
                                                                </td>
                                                                <td>
                                                                    <img
                                                                        src="../../images/courses/1745333269ncert-groupd.png"
                                                                        alt=""
                                                                        width={70}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <a href="view_course_features.php?course_id=2">
                                                                        Features
                                                                    </a>
                                                                </td>
                                                                <td>
                                                                    <a href="view_course_faq.php?course_id=2">FAQs</a>
                                                                </td>
                                                                <td>
                                                                    <a
                                                                        href=""
                                                                        id="f_status"
                                                                        onclick="franchise_status(2)"
                                                                    >
                                                                        <span className="badge bg-success text-white fs-14 rounded-2">
                                                                            Active
                                                                        </span>
                                                                    </a>
                                                                </td>
                                                                <td>
                                                                    <a
                                                                        href="edit_courses.php?id=2"
                                                                        className="bg-primary-transparent text-primary p-2 rounded-2 text-center fs-16 me-2"
                                                                    >
                                                                        <i className="fe fe-edit" />
                                                                    </a>
                                                                    <a
                                                                        href=""
                                                                        id="f_status"
                                                                        className="bg-danger-transparent text-danger p-2 rounded-2 text-center fs-16"
                                                                        onclick="delete_f(2)"
                                                                    >
                                                                        <i className="fe fe-trash-2" />
                                                                    </a>
                                                                </td>
                                                            </tr>
                                                            <tr className="odd">
                                                                <td className="sorting_1">3</td>
                                                                <td>RRB</td>
                                                                <td />
                                                                <td>
                                                                    199 रूपए में कम्पलीट साइंस रिकॉर्डेड बैच (Physics
                                                                    chemistry biology) स्पेशल रेलवे के लिए
                                                                </td>
                                                                <td>
                                                                    <p>
                                                                        MOST WEL-COME DABRA CLASSES JAIPUR
                                                                        ||&nbsp;&lt;...
                                                                    </p>
                                                                </td>
                                                                <td>
                                                                    <img
                                                                        src="../../images/courses/1745333743SCIENCE SPL. BATCH (DABRA SIR).png"
                                                                        alt=""
                                                                        width={70}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <a href="view_course_features.php?course_id=3">
                                                                        Features
                                                                    </a>
                                                                </td>
                                                                <td>
                                                                    <a href="view_course_faq.php?course_id=3">FAQs</a>
                                                                </td>
                                                                <td>
                                                                    <a
                                                                        href=""
                                                                        id="f_status"
                                                                        onclick="franchise_status(3)"
                                                                    >
                                                                        <span className="badge bg-danger text-white fs-14 rounded-2">
                                                                            Blocked
                                                                        </span>
                                                                    </a>
                                                                </td>
                                                                <td>
                                                                    <a
                                                                        href="edit_courses.php?id=3"
                                                                        className="bg-primary-transparent text-primary p-2 rounded-2 text-center fs-16 me-2"
                                                                    >
                                                                        <i className="fe fe-edit" />
                                                                    </a>
                                                                    <a
                                                                        href=""
                                                                        id="f_status"
                                                                        className="bg-danger-transparent text-danger p-2 rounded-2 text-center fs-16"
                                                                        onclick="delete_f(3)"
                                                                    >
                                                                        <i className="fe fe-trash-2" />
                                                                    </a>
                                                                </td>
                                                            </tr>
                                                            <tr className="even">
                                                                <td className="sorting_1">4</td>
                                                                <td>RRB</td>
                                                                <td />
                                                                <td>
                                                                    149रूपये मे Physics &amp; Chemistry रिकॉर्डेड बैच
                                                                    RAILWAY 2025 GROUP-D/NTPC/ALP/TECH/JE
                                                                </td>
                                                                <td>
                                                                    <p>
                                                                        MOST WEL-COME DABRA CLASSES JAIPUR
                                                                        ||&nbsp;&lt;...
                                                                    </p>
                                                                </td>
                                                                <td>
                                                                    <img
                                                                        src="../../images/courses/1745334007NCERT PHYSICS & CHEMISTRY.jpg"
                                                                        alt=""
                                                                        width={70}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <a href="view_course_features.php?course_id=4">
                                                                        Features
                                                                    </a>
                                                                </td>
                                                                <td>
                                                                    <a href="view_course_faq.php?course_id=4">FAQs</a>
                                                                </td>
                                                                <td>
                                                                    <a
                                                                        href=""
                                                                        id="f_status"
                                                                        onclick="franchise_status(4)"
                                                                    >
                                                                        <span className="badge bg-danger text-white fs-14 rounded-2">
                                                                            Blocked
                                                                        </span>
                                                                    </a>
                                                                </td>
                                                                <td>
                                                                    <a
                                                                        href="edit_courses.php?id=4"
                                                                        className="bg-primary-transparent text-primary p-2 rounded-2 text-center fs-16 me-2"
                                                                    >
                                                                        <i className="fe fe-edit" />
                                                                    </a>
                                                                    <a
                                                                        href=""
                                                                        id="f_status"
                                                                        className="bg-danger-transparent text-danger p-2 rounded-2 text-center fs-16"
                                                                        onclick="delete_f(4)"
                                                                    >
                                                                        <i className="fe fe-trash-2" />
                                                                    </a>
                                                                </td>
                                                            </tr>
                                                            <tr className="odd">
                                                                <td className="sorting_1">5</td>
                                                                <td>RRB</td>
                                                                <td />
                                                                <td>राजस्थान चतुर्थ श्रेणी भर्ती रिकॉर्डेड बैच</td>
                                                                <td>
                                                                    <p>&nbsp;</p>
                                                                </td>
                                                                <td>
                                                                    <img
                                                                        src="../../images/courses/1745334356genral.science.png"
                                                                        alt=""
                                                                        width={70}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <a href="view_course_features.php?course_id=5">
                                                                        Features
                                                                    </a>
                                                                </td>
                                                                <td>
                                                                    <a href="view_course_faq.php?course_id=5">FAQs</a>
                                                                </td>
                                                                <td>
                                                                    <a
                                                                        href=""
                                                                        id="f_status"
                                                                        onclick="franchise_status(5)"
                                                                    >
                                                                        <span className="badge bg-success text-white fs-14 rounded-2">
                                                                            Active
                                                                        </span>
                                                                    </a>
                                                                </td>
                                                                <td>
                                                                    <a
                                                                        href="edit_courses.php?id=5"
                                                                        className="bg-primary-transparent text-primary p-2 rounded-2 text-center fs-16 me-2"
                                                                    >
                                                                        <i className="fe fe-edit" />
                                                                    </a>
                                                                    <a
                                                                        href=""
                                                                        id="f_status"
                                                                        className="bg-danger-transparent text-danger p-2 rounded-2 text-center fs-16"
                                                                        onclick="delete_f(5)"
                                                                    >
                                                                        <i className="fe fe-trash-2" />
                                                                    </a>
                                                                </td>
                                                            </tr>
                                                            <tr className="even">
                                                                <td className="sorting_1">6</td>
                                                                <td>RRB</td>
                                                                <td />
                                                                <td>
                                                                    GROUP-D कम्पलीट लाइव बैच MATH,REASONING,GK &amp;
                                                                    SCIENCE
                                                                </td>
                                                                <td>
                                                                    <p>
                                                                        यह कोर्स आपके फोन में 1 साल तक रहेगा किसी भी...
                                                                    </p>
                                                                </td>
                                                                <td>
                                                                    <img
                                                                        src="../../images/courses/1745334793recorded.batch.png"
                                                                        alt=""
                                                                        width={70}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <a href="view_course_features.php?course_id=6">
                                                                        Features
                                                                    </a>
                                                                </td>
                                                                <td>
                                                                    <a href="view_course_faq.php?course_id=6">FAQs</a>
                                                                </td>
                                                                <td>
                                                                    <a
                                                                        href=""
                                                                        id="f_status"
                                                                        onclick="franchise_status(6)"
                                                                    >
                                                                        <span className="badge bg-danger text-white fs-14 rounded-2">
                                                                            Blocked
                                                                        </span>
                                                                    </a>
                                                                </td>
                                                                <td>
                                                                    <a
                                                                        href="edit_courses.php?id=6"
                                                                        className="bg-primary-transparent text-primary p-2 rounded-2 text-center fs-16 me-2"
                                                                    >
                                                                        <i className="fe fe-edit" />
                                                                    </a>
                                                                    <a
                                                                        href=""
                                                                        id="f_status"
                                                                        className="bg-danger-transparent text-danger p-2 rounded-2 text-center fs-16"
                                                                        onclick="delete_f(6)"
                                                                    >
                                                                        <i className="fe fe-trash-2" />
                                                                    </a>
                                                                </td>
                                                            </tr>
                                                            <tr className="odd">
                                                                <td className="sorting_1">7</td>
                                                                <td>RRB</td>
                                                                <td />
                                                                <td>
                                                                    99रूपये मे NCERT PHYSICS रिकॉर्डेड बैच
                                                                    GROUP-D/NTPC/ALP/TECH &amp; All Exam’s
                                                                </td>
                                                                <td>
                                                                    <p>
                                                                        प्रिय विद्यार्थियों कोर्स खरीदने से पहले दिश...
                                                                    </p>
                                                                </td>
                                                                <td>
                                                                    <img
                                                                        src="../../images/courses/1745335075PHYSICS SPECIAL.png"
                                                                        alt=""
                                                                        width={70}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <a href="view_course_features.php?course_id=7">
                                                                        Features
                                                                    </a>
                                                                </td>
                                                                <td>
                                                                    <a href="view_course_faq.php?course_id=7">FAQs</a>
                                                                </td>
                                                                <td>
                                                                    <a
                                                                        href=""
                                                                        id="f_status"
                                                                        onclick="franchise_status(7)"
                                                                    >
                                                                        <span className="badge bg-danger text-white fs-14 rounded-2">
                                                                            Blocked
                                                                        </span>
                                                                    </a>
                                                                </td>
                                                                <td>
                                                                    <a
                                                                        href="edit_courses.php?id=7"
                                                                        className="bg-primary-transparent text-primary p-2 rounded-2 text-center fs-16 me-2"
                                                                    >
                                                                        <i className="fe fe-edit" />
                                                                    </a>
                                                                    <a
                                                                        href=""
                                                                        id="f_status"
                                                                        className="bg-danger-transparent text-danger p-2 rounded-2 text-center fs-16"
                                                                        onclick="delete_f(7)"
                                                                    >
                                                                        <i className="fe fe-trash-2" />
                                                                    </a>
                                                                </td>
                                                            </tr>
                                                            <tr className="even">
                                                                <td className="sorting_1">8</td>
                                                                <td>RRB</td>
                                                                <td />
                                                                <td>Maths + रीजनिंग + GK स्पेशल लाइव बैच</td>
                                                                <td>
                                                                    <p>&nbsp;</p>
                                                                </td>
                                                                <td>
                                                                    <img
                                                                        src="../../images/courses/1745336101MATH, REASONING, G.K. APPLICATION BANNER.png"
                                                                        alt=""
                                                                        width={70}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <a href="view_course_features.php?course_id=10">
                                                                        Features
                                                                    </a>
                                                                </td>
                                                                <td>
                                                                    <a href="view_course_faq.php?course_id=10">
                                                                        FAQs
                                                                    </a>
                                                                </td>
                                                                <td>
                                                                    <a
                                                                        href=""
                                                                        id="f_status"
                                                                        onclick="franchise_status(10)"
                                                                    >
                                                                        <span className="badge bg-danger text-white fs-14 rounded-2">
                                                                            Blocked
                                                                        </span>
                                                                    </a>
                                                                </td>
                                                                <td>
                                                                    <a
                                                                        href="edit_courses.php?id=10"
                                                                        className="bg-primary-transparent text-primary p-2 rounded-2 text-center fs-16 me-2"
                                                                    >
                                                                        <i className="fe fe-edit" />
                                                                    </a>
                                                                    <a
                                                                        href=""
                                                                        id="f_status"
                                                                        className="bg-danger-transparent text-danger p-2 rounded-2 text-center fs-16"
                                                                        onclick="delete_f(10)"
                                                                    >
                                                                        <i className="fe fe-trash-2" />
                                                                    </a>
                                                                </td>
                                                            </tr>
                                                            <tr className="odd">
                                                                <td className="sorting_1">9</td>
                                                                <td>RRB</td>
                                                                <td />
                                                                <td>मैथ + साइंस लाइव बैच RAILWAY-2025</td>
                                                                <td>
                                                                    <p>
                                                                        यह कोर्स आपके फोन में 1 साल तक रहेगा किसी भी...
                                                                    </p>
                                                                </td>
                                                                <td>
                                                                    <img
                                                                        src="../../images/courses/1745336288MATHS & SCIENCE APPLICATION BANNER (DABRA SIR, MANOJ SIR).png"
                                                                        alt=""
                                                                        width={70}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <a href="view_course_features.php?course_id=11">
                                                                        Features
                                                                    </a>
                                                                </td>
                                                                <td>
                                                                    <a href="view_course_faq.php?course_id=11">
                                                                        FAQs
                                                                    </a>
                                                                </td>
                                                                <td>
                                                                    <a
                                                                        href=""
                                                                        id="f_status"
                                                                        onclick="franchise_status(11)"
                                                                    >
                                                                        <span className="badge bg-danger text-white fs-14 rounded-2">
                                                                            Blocked
                                                                        </span>
                                                                    </a>
                                                                </td>
                                                                <td>
                                                                    <a
                                                                        href="edit_courses.php?id=11"
                                                                        className="bg-primary-transparent text-primary p-2 rounded-2 text-center fs-16 me-2"
                                                                    >
                                                                        <i className="fe fe-edit" />
                                                                    </a>
                                                                    <a
                                                                        href=""
                                                                        id="f_status"
                                                                        className="bg-danger-transparent text-danger p-2 rounded-2 text-center fs-16"
                                                                        onclick="delete_f(11)"
                                                                    >
                                                                        <i className="fe fe-trash-2" />
                                                                    </a>
                                                                </td>
                                                            </tr>
                                                            <tr className="even">
                                                                <td className="sorting_1">10</td>
                                                                <td>RRB</td>
                                                                <td />
                                                                <td>
                                                                    NCERT SCIENCE SPECIAL रिकॉर्डेड बैच GROUP-D/NTPC/
                                                                    ALP/TECH/JE 16312
                                                                </td>
                                                                <td>
                                                                    <p>
                                                                        MOST WEL-COME DABRA CLASSES JAIPUR
                                                                        ||&nbsp;&lt;...
                                                                    </p>
                                                                </td>
                                                                <td>
                                                                    <img
                                                                        src="../../images/courses/1745336548MahaOffer Railway Group-D Science Special Batch Recorded (1).png"
                                                                        alt=""
                                                                        width={70}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <a href="view_course_features.php?course_id=12">
                                                                        Features
                                                                    </a>
                                                                </td>
                                                                <td>
                                                                    <a href="view_course_faq.php?course_id=12">
                                                                        FAQs
                                                                    </a>
                                                                </td>
                                                                <td>
                                                                    <a
                                                                        href=""
                                                                        id="f_status"
                                                                        onclick="franchise_status(12)"
                                                                    >
                                                                        <span className="badge bg-danger text-white fs-14 rounded-2">
                                                                            Blocked
                                                                        </span>
                                                                    </a>
                                                                </td>
                                                                <td>
                                                                    <a
                                                                        href="edit_courses.php?id=12"
                                                                        className="bg-primary-transparent text-primary p-2 rounded-2 text-center fs-16 me-2"
                                                                    >
                                                                        <i className="fe fe-edit" />
                                                                    </a>
                                                                    <a
                                                                        href=""
                                                                        id="f_status"
                                                                        className="bg-danger-transparent text-danger p-2 rounded-2 text-center fs-16"
                                                                        onclick="delete_f(12)"
                                                                    >
                                                                        <i className="fe fe-trash-2" />
                                                                    </a>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-12 col-md-5">
                                                    <div
                                                        className="dataTables_info"
                                                        id="UserList_info"
                                                        role="status"
                                                        aria-live="polite"
                                                    >
                                                        Showing 1 to 10 of 32 entries
                                                    </div>
                                                </div>
                                                <div className="col-sm-12 col-md-7">
                                                    <div
                                                        className="dataTables_paginate paging_simple_numbers"
                                                        id="UserList_paginate"
                                                    >
                                                        <ul className="pagination">
                                                            <li
                                                                className="paginate_button page-item previous disabled"
                                                                id="UserList_previous"
                                                            >
                                                                <a
                                                                    aria-controls="UserList"
                                                                    aria-disabled="true"
                                                                    aria-role="link"
                                                                    data-dt-idx="previous"
                                                                    tabIndex={0}
                                                                    className="page-link"
                                                                >
                                                                    Previous
                                                                </a>
                                                            </li>
                                                            <li className="paginate_button page-item active">
                                                                <a
                                                                    href="#"
                                                                    aria-controls="UserList"
                                                                    aria-role="link"
                                                                    aria-current="page"
                                                                    data-dt-idx={0}
                                                                    tabIndex={0}
                                                                    className="page-link"
                                                                >
                                                                    1
                                                                </a>
                                                            </li>
                                                            <li className="paginate_button page-item ">
                                                                <a
                                                                    href="#"
                                                                    aria-controls="UserList"
                                                                    aria-role="link"
                                                                    data-dt-idx={1}
                                                                    tabIndex={0}
                                                                    className="page-link"
                                                                >
                                                                    2
                                                                </a>
                                                            </li>
                                                            <li className="paginate_button page-item ">
                                                                <a
                                                                    href="#"
                                                                    aria-controls="UserList"
                                                                    aria-role="link"
                                                                    data-dt-idx={2}
                                                                    tabIndex={0}
                                                                    className="page-link"
                                                                >
                                                                    3
                                                                </a>
                                                            </li>
                                                            <li className="paginate_button page-item ">
                                                                <a
                                                                    href="#"
                                                                    aria-controls="UserList"
                                                                    aria-role="link"
                                                                    data-dt-idx={3}
                                                                    tabIndex={0}
                                                                    className="page-link"
                                                                >
                                                                    4
                                                                </a>
                                                            </li>
                                                            <li
                                                                className="paginate_button page-item next"
                                                                id="UserList_next"
                                                            >
                                                                <a
                                                                    href="#"
                                                                    aria-controls="UserList"
                                                                    aria-role="link"
                                                                    data-dt-idx="next"
                                                                    tabIndex={0}
                                                                    className="page-link"
                                                                >
                                                                    Next
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/*{ container end }*/}
            </div>
        </div>


    );
};

export default CourseList;
;
